"use client"

import { motion } from "framer-motion"
import ScrollText from "./ScrollText"

export default function PartnersSection() {
  const partners = [
    {
      name: "DBN",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/DBN-vEAH5PKG0cWIg4H4nEg58hMkNmxEBO.png",
    },
    {
      name: "ACLO",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/ACLO-pvMdHKmirVkOBaOhfeqJS4meOq4a6j.png",
    },
    {
      name: "Dodgeball World",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/DBW-d6ez99UybC0E09Z4vAvx8PK3BTG78E.png",
    },
    {
      name: "Jeugdfonds Sport & Cultuur",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/SJC-w23jOofxmH1ra69x9NpmBjUj3frgQv.png",
    },
    {
      name: "Volwassenenfonds Sport & Cultuur",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/SVC-8UYAiB4v4vAB5xr6sXIxgoDQCKTDue.png",
    },
    {
      name: "Urban Sports Club",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/USC-Jvp54P0BKQCHhWgR89IRqFJnGGSx9E.png",
    },
  ]

  return (
    <section className="py-16 px-4 bg-white/30">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <ScrollText text="OUR PARTNERS" className="text-sm font-semibold text-orange-500 mb-4 tracking-wider" />
          <ScrollText
            text="Trusted by leading sports organizations"
            className="text-2xl md:text-3xl font-bold mb-8 text-dark"
          />
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 items-center">
          {partners.map((partner, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="flex items-center justify-center p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow aspect-square"
            >
              <img
                src={partner.logo || "/placeholder.svg"}
                alt={partner.name}
                className="max-h-10 max-w-full w-auto object-contain"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
